module.exports = __webpack_public_path__ + "files/72097456ba7a2a7744c732204d39d807.png";